<input class="switch-form-default form-check-input col-2" 
[id]="givenId" 
(click)="emitValue($event)" 
type="checkbox" 
role="switch" 
[checked]="myValue"
[disabled]="valueShouldBeDisabled"> 